<script setup lang="ts">
import { NxtSkeleton } from '@future-harry/nxt-styles';
</script>

<template>
   <div>
      <NxtSkeleton width="80%" class="mb-gutter" />
      <NxtSkeleton width="40%" class="mb-gutter" />
      <NxtSkeleton width="40%" class="mb-gutter" />
      <NxtSkeleton width="40%" class="mb-gutter-xlarge" />
      <NxtSkeleton width="80%" class="mb-gutter" />
      <NxtSkeleton width="40%" class="mb-gutter" />
      <NxtSkeleton width="40%" class="mb-gutter" />
      <NxtSkeleton width="40%" />
   </div>
</template>

<style lang="scss" scoped>
.mb-gutter {
   margin-bottom: var(--nxt-gutter);
}

.mb-gutter-xlarge {
   margin-bottom: var(--nxt-gutter-xlarge);
}
</style>
